import React from 'react';
import styles from './FormStepper.module.css';

const FormStepper = ({ steps, currentStep }) => {
  return (
    <div className={styles.stepper}>
      {steps.map((step, index) => (
        <div 
          key={step.id} 
          className={`
            ${styles.step}
            ${index < currentStep ? styles.completed : ''}
            ${index === currentStep ? styles.active : ''}
          `}
        >
          <div className={styles.stepNumber}>
            {index < currentStep ? (
              <svg 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                className={styles.checkIcon}
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={3} 
                  d="M5 13l4 4L19 7"
                />
              </svg>
            ) : (
              index + 1
            )}
          </div>
          <div className={styles.stepContent}>
            <div className={styles.stepTitle}>{step.title}</div>
            <div className={styles.stepDescription}>{step.description}</div>
          </div>
          {index < steps.length - 1 && (
            <div className={styles.connector} />
          )}
        </div>
      ))}
    </div>
  );
};

export default FormStepper;